module.exports = __webpack_public_path__ + "files/9c7750c16d08a7e62857bd6c03330e8b.png";